var styleDataHash = "b2594d0c";
const injectCss = () => {
  var css = `.YqdmD,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._9zXYM,.iNDWa{height:386px;overflow:auto}[dir] ._9zXYM,[dir] .iNDWa{margin-top:20px}[dir=ltr] ._9zXYM,[dir=ltr] .iNDWa{margin-right:-16px;padding-right:16px}[dir=rtl] ._9zXYM,[dir=rtl] .iNDWa{margin-left:-16px;padding-left:16px}._9zXYM.LXiSL,.iNDWa.LXiSL{height:calc(100vh - 190px)}.af-7U{display:flex;flex-direction:column}[dir=ltr] .M7u2h{float:right;text-align:right}[dir=rtl] .M7u2h{float:left;text-align:left}[dir] .YiEJu{cursor:pointer}.ls6M-{align-items:center;display:flex;height:100%;justify-content:center;width:100%}[dir] .ls6M-{margin-top:50px}.y-cM5{height:100%;width:100%}._9zXYM,.y-cM5{align-items:center;display:flex;justify-content:center}._9zXYM{max-width:100%}.rTOWK{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_selector_default = {
  "fontElementMap": "YqdmD",
  "giphy_selector_infinite_scroll_container": "iNDWa",
  "giphySelectorErrorContainer": "_9zXYM",
  "mobile": "LXiSL",
  "giphy_selector_infinite_scroll": "af-7U",
  "giphy_selector_powerdByGiphy": "M7u2h",
  "giphy_selector_gif_img_container": "YiEJu",
  "giphy_selector_spinner_load_more": "ls6M-",
  "giphy_selector_spinner_empty_modal": "y-cM5",
  "searchInput": "rTOWK"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
